import React from 'react';
import { X } from 'lucide-react';

const SearchBar = ({ 
  searchTerm, 
  setSearchTerm, 
  searchField, 
  setSearchField, 
  handleSearch, 
  clearSearch, 
  isLoading, 
  isSearching 
}) => {
  return (
    <div className="mb-4 flex flex-row flex-wrap items-center gap-2">
      <div className="flex-1 min-w-0">
        <div className="relative flex items-center min-w-0">
          <select
            value={searchField}
            onChange={(e) => setSearchField(e.target.value)}
            className="h-[34px] w-auto px-2 sm:px-3 text-[13px] font-medium bg-gray-100 border border-gray-300 rounded-l-lg focus:outline-none shrink-0"
            disabled={isLoading}
          >
            <option value="all">All Fields</option>
            <option value="id">ID</option>
            <option value="domain">Domain</option>
            <option value="useCase">Use Case</option>
            <option value="agent">Agent</option>
            <option value="customerId">Customer</option>
            <option value="endpoint">Endpoint</option>
            <option value="prompt">Prompt</option>
            <option value="model">Model</option>
          </select>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
            placeholder="Search prompts..."
            className="h-[34px] w-full px-2 sm:px-3 text-[13px] border border-l-0 border-gray-300 rounded-l-none rounded-r-lg focus:ring-primary focus:border-primary"
            disabled={isLoading}
          />
          {searchTerm && (
            <button
              onClick={() => setSearchTerm('')}
              className="absolute right-3 text-gray-400 hover:text-gray-600"
              disabled={isLoading}
            >
              <X size={16} />
            </button>
          )}
        </div>
      </div>

      <button
        onClick={handleSearch}
        className="h-[34px] px-3 py-1.5 text-[13px] font-medium bg-primary text-white rounded-lg hover:bg-primaryDark flex items-center"
        disabled={isLoading}
      >
        {isSearching ? (
          <>
            <div className="w-3 h-3 border-2 border-t-white border-white border-opacity-20 rounded-full animate-spin mr-2"></div>
            Searching...
          </>
        ) : (
          'Search'
        )}
      </button>

      {searchTerm && (
        <button
          onClick={clearSearch}
          className="h-[34px] px-3 py-1.5 text-[13px] font-medium bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
          disabled={isLoading}
        >
          Clear
        </button>
      )}
    </div>
  );
};

export default SearchBar;